export default __webpack_public_path__ + "static/3-1--4200c5b816b4920ee7b45e534b145a3c.png";